import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importStorefront = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "Storefront" */
                '@perpay-web/storefront/index'
            ),
    );
